export const SHIPPING_ON_THE_WAY_STATUSES = ['lms_sent', 'transport', 'awizo'];
export const SHIPPING_NOT_SEND_STATUSES = [
	'to_send',
	'stand_by',
	'in_explanation',
];
